import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { Simplify } from 'type-fest';

import { isPresent } from './helpers';
import type { PickByPrefix, RemovePrefix, StyleClasses } from './types';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function removePrefix<T extends StyleClasses, Prefix extends string>(classes: T, prefix: Prefix) {
  const prefixedClasses = Object.entries(classes)
    .filter((entry): entry is [string, string] => entry[0]?.startsWith(prefix) && isPresent(entry[1]))
    .map(([key, value]) => [key.slice(prefix.length), value] as const);

  return Object.fromEntries(prefixedClasses) as Simplify<
    NonNullable<{
      [K in keyof PickByPrefix<T, Prefix> as K extends string ? RemovePrefix<K, Prefix> : never]: PickByPrefix<
        T,
        Prefix
      >[K];
    }>
  >;
}
